__turbopack_context__.v({
  "Mwebsubheading": "NsatBanner-module-scss-module__4Zn0pG__Mwebsubheading",
  "banner": "NsatBanner-module-scss-module__4Zn0pG__banner",
  "circleLarge": "NsatBanner-module-scss-module__4Zn0pG__circleLarge",
  "content": "NsatBanner-module-scss-module__4Zn0pG__content",
  "ctaButton": "NsatBanner-module-scss-module__4Zn0pG__ctaButton",
  "description": "NsatBanner-module-scss-module__4Zn0pG__description",
  "heading": "NsatBanner-module-scss-module__4Zn0pG__heading",
  "highlightText": "NsatBanner-module-scss-module__4Zn0pG__highlightText",
  "image": "NsatBanner-module-scss-module__4Zn0pG__image",
  "imageWrapper": "NsatBanner-module-scss-module__4Zn0pG__imageWrapper",
  "img": "NsatBanner-module-scss-module__4Zn0pG__img",
  "mwebHeading": "NsatBanner-module-scss-module__4Zn0pG__mwebHeading",
  "subheading": "NsatBanner-module-scss-module__4Zn0pG__subheading",
  "textYellow": "NsatBanner-module-scss-module__4Zn0pG__textYellow",
  "urgency": "NsatBanner-module-scss-module__4Zn0pG__urgency",
  "urgencyIcon": "NsatBanner-module-scss-module__4Zn0pG__urgencyIcon",
});
